import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import PortalAppBar from './PortalAppBar';
import { useAccount } from '../App';
import { useStyles } from '../containers/HomePage/HomePage.styles';
import { useLayout } from '../contexts/LayoutContext';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const classes = useStyles();
  const { activeAccount } = useAccount();
  const navigate = useNavigate();
  const { useGrid, handleToggle, selectedRequestType } = useLayout();

  // Back to home handler
  const handleBackToHome = useCallback(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return (
    <>
      <PortalAppBar
        selectedRequestType={selectedRequestType}
        useGrid={useGrid}
        handleToggle={handleToggle}
        handleBackToHome={handleBackToHome}
        classes={classes}
        activeAccount={activeAccount ?? undefined}
      />

      <div style={{ height: 70 }} />
      {children}
    </>
  );
}
